import React from 'react';
import ReportViewer from "./base/ReportViewer";

const AchalandageMensuelActivitésLieuxSejours = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"AchalandageMensuelActivitésLieuxSéjours"}/>
        </div>
    );
}
export default AchalandageMensuelActivitésLieuxSejours;